import { PropsWithChildren, useMemo } from "react";
import { Article, Container } from "./styles";

export type ArticlesProps = PropsWithChildren<{
  articles: {
    _id: string;
    heading: string;
    category: string | null;
    releaseDate: string;
    slug: string;
    excerpt: string;
    thumbnail: {
      asset: {
        url: string;
      };
    };
  }[];
}>;

const Articles: React.FC<ArticlesProps> = (props) => {
  const { articles, children } = props;

  // There is a bug in the fetcher that creates duplicate article entries
  const dedupedArticles = useMemo(() => {
    const ids = new Set(articles.map((article) => article._id));
    const list: typeof articles = [];

    ids.forEach((id) => {
      const article = articles.find((article) => article._id === id);
      if (article) list.push(article);
    });

    return list;
  }, [articles]);

  return (
    <Container>
      {dedupedArticles.map((article) => (
        <Article key={article._id} headingStyle="h2" {...article} />
      ))}
      {children}
    </Container>
  );
};

export default Articles;
